
import { MessageCircle, Brain, Video, Zap, Book, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard = ({ icon, title, description }: FeatureCardProps) => (
  <Card className="border-none shadow-none bg-transparent hover:bg-accent/5 transition-colors duration-300">
    <CardHeader>
      <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
        {icon}
      </div>
      <CardTitle className="text-xl mb-2">{title}</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground">{description}</p>
    </CardContent>
  </Card>
);

export const FeatureSection = () => {
  return (
    <section id="features" className="py-16 md:py-24 bg-muted/50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          How MindTube Works
        </h2>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-12">
          Why passive watching doesn't work: Transform your learning experience with our AI-powered features
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard
            icon={<MessageCircle />}
            title="Interactive Chat"
            description="Ask questions and get instant, context-aware answers from any YouTube video using advanced AI technology."
          />
          <FeatureCard
            icon={<Brain />}
            title="AI-Driven Insights"
            description="Our AI analyzes video content deeply, providing comprehensive understanding beyond just transcripts."
          />
          <FeatureCard
            icon={<Video />}
            title="Seamless Integration"
            description="Works with any YouTube video instantly. Just paste the link and start your interactive learning journey."
          />
          <FeatureCard
            icon={<Zap />}
            title="Real-Time Learning"
            description="Get immediate responses to your questions, making learning efficient and engaging."
          />
          <FeatureCard
            icon={<Book />}
            title="Deep Understanding"
            description="Extract key concepts and insights from videos, enhancing knowledge retention."
          />
          <FeatureCard
            icon={<Clock />}
            title="Time-Efficient"
            description="Save hours by quickly accessing the specific information you need from any video."
          />
        </div>
      </div>
    </section>
  );
};
